// Deterministic, no-backend-field-needed color per kelompok (hasil meet.txt
// case 2: "beda kelompok beda collor"). Purely decorative — nothing ever
// authorizes against this, so it's computed here from team.id rather than
// stored, and needs no migration/backfill for kelompok that already exist.
const PALETTE = [
  "#f87171", // red
  "#fb923c", // orange
  "#fbbf24", // amber
  "#a3e635", // lime
  "#34d399", // emerald
  "#22d3ee", // cyan
  "#60a5fa", // blue
  "#818cf8", // indigo
  "#c084fc", // purple
  "#f472b6", // pink
];

export function teamColor(teamId) {
  if (teamId === null || teamId === undefined || teamId === "") {
    return "var(--text-secondary)";
  }
  const n = Number(teamId);
  if (!Number.isFinite(n)) return "var(--text-secondary)";
  return PALETTE[Math.abs(n) % PALETTE.length];
}

export default teamColor;
